import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'María González',
  location: 'Ciudad de México',
  text: 'Estaba cansada de que el dinero no alcanzara. Aprendí a hacer las placas aromáticas en un día y ya vendí mis primeras 10. ¡No puedo creer lo fácil que es!',
  urgency: 'Empecé hace 2 semanas'
}, {
  name: 'Laura Ramírez',
  location: 'Monterrey',
  text: 'Probé con velas antes y fue un desastre. Las placas aromáticas son MUCHO más fáciles y rentables. Ya recuperé mi inversión y voy por más.',
  urgency: 'Recuperé la inversión en 5 días'
}, {
  name: 'Ana Martínez',
  location: 'Guadalajara',
  text: 'Tenía miedo de gastar dinero en otro curso. Pero este es diferente: paso a paso, con proveedores y TODO. Mis amigas ya me están pidiendo placas.',
  urgency: 'Primera venta en 24 horas'
}, {
  name: 'Sofía Torres',
  location: 'Buenos Aires',
  text: 'Soy mamá de dos y necesitaba algo que pudiera hacer desde casa. Las placas aromáticas son perfectas: rápidas, lindas y se venden solas.',
  urgency: 'Genero ingresos desde casa'
}, {
  name: 'Carolina López',
  location: 'Puebla',
  text: 'El curso es súper claro y los bonos valen oro. El taller de Wax Melts me abrió otra fuente de ingresos. Mejor decisión del año.',
  urgency: 'Duplicó su catálogo de productos'
}, {
  name: 'Valentina Cruz',
  location: 'Córdoba',
  text: 'No sabía nada de emprendimientos. Ahora tengo mi propio negocio de placas aromáticas y estoy feliz. El soporte 24/7 me salvó varias veces.',
  urgency: 'De cero a emprendedora'
}];
export function TestimonialsSection() {
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-243">
      <div className="container mx-auto max-w-6xl" data-id="element-244">
        <div className="text-center mb-8 md:mb-12" data-id="element-245">
          <h2 className="text-3xl md:text-5xl font-extrabold text-pink-600 mb-4 leading-tight" data-id="element-246">
            Lo Que Dicen Mujeres Como Vos
          </h2>
          <p className="text-lg md:text-2xl text-rose-500 font-bold" data-id="element-247">
            Que dieron el paso y cambiaron su situación económica
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-248">
          {testimonials.map((testimonial, index) => <article key={index} className="bg-pink-50 border-2 border-pink-300 rounded-xl p-6 shadow-xl" data-id="element-249">
              {/* Stars */}
              <div className="flex gap-1 mb-4" role="img" aria-label="5 estrellas" data-id="element-250">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-251" />)}
              </div>

              {/* Quote */}
              <QuoteIcon className="w-8 h-8 text-rose-400 mb-3" aria-hidden="true" data-id="element-252" />
              <p className="text-base md:text-lg text-stone-700 mb-4 font-semibold leading-relaxed" data-id="element-253">
                "{testimonial.text}"
              </p>

              {/* Urgency badge */}
              <div className="bg-gradient-to-r from-pink-500 to-rose-500 text-white px-3 py-2 rounded-lg mb-4 inline-block shadow-md" data-id="element-254">
                <p className="text-xs md:text-sm font-bold uppercase" data-id="element-255">
                  ✓ {testimonial.urgency}
                </p>
              </div>

              {/* Author */}
              <div data-id="element-256">
                <p className="text-base md:text-lg text-pink-600 font-bold" data-id="element-257">
                  {testimonial.name}
                </p>
                <p className="text-sm text-stone-500" data-id="element-258">{testimonial.location}</p>
              </div>
            </article>)}
        </div>

        {/* Social proof */}
        <div className="mt-8 md:mt-12 text-center" data-id="element-259">
          <p className="text-xl md:text-3xl text-pink-600 font-extrabold mb-2" data-id="element-260">
            +1,200 mujeres ya están generando ingresos
          </p>
          <p className="text-base md:text-xl text-rose-500 font-bold uppercase" data-id="element-261">
            ¿Vas a quedarte afuera?
          </p>
        </div>
      </div>
    </section>;
}